import { useMemo } from 'react'
import { observer } from 'mobx-react-lite'
import { Table, TableSearch } from 'shared/ui/TableNew'
import { useCustomFieldsContext } from 'pages/settings/pages/customFields/context/customFieldsContext'
import { getCustomFieldsTableActions } from './getCustomFieldsTableActions'
import { columns } from './columns'
import styles from './styles.module.scss'

export const CustomFieldsTable = observer(() => {
  const {
    tableStore,
    initialLoading,
    changePaging,
    customFields,
    loadCustomFields,
    handleDeleteSuccess,
    search,
    setSearch,
    getFieldTypeLabel,
  } = useCustomFieldsContext()

  const tableColumns = useMemo(
    () =>
      columns({
        getFieldTypeLabel,
      }),
    [getFieldTypeLabel]
  )

  const rows = useMemo(() => {
    return customFields.map((item) => {
      item.setActionsProps({
        actions: getCustomFieldsTableActions(item, loadCustomFields, handleDeleteSuccess),
      })

      return item
    })
  }, [customFields])

  return (
    <section className={styles.table}>
      <TableSearch value={search} onChange={setSearch} />
      <Table
        ariaLabel={'CustomFieldsTable'}
        store={tableStore}
        columns={tableColumns}
        rows={rows}
        loading={initialLoading}
        onChangePagination={changePaging}
        pinnedColumnIds={['name']}
      />
    </section>
  )
})
